import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: "Un dimanche soir en pleurant, j'ai acheté cet ebook. Le lundi matin, j'avais trié ma garde-robe. Ce geste m'a redonné un pouvoir que je n'avais pas senti depuis des années.",
  author: 'Isabelle, 43 ans, Québec'
}, {
  quote: "C'est comme si quelqu'un avait enfin mis des mots sur tout ce que je ressentais sans pouvoir l'expliquer.",
  author: 'Marie-Claire, 38 ans, Lyon'
}, {
  quote: "La solitude... je n'en avais plus peur. Je l'attendais.",
  author: 'Sophie, 51 ans, Montréal'
}];
export function TestimonialsSection() {
  return <section className="bg-cream py-10 px-6 md:py-16" data-id="element-257">
      <div className="max-w-5xl mx-auto" data-id="element-258">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-259">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-lg border-l-4 border-burgundy" data-id="element-260">
              <div className="text-gold mb-3 text-lg" data-id="element-261">⭐⭐⭐⭐⭐</div>
              <p className="italic text-charcoal mb-4 leading-relaxed" data-id="element-262">
                "{testimonial.quote}"
              </p>
              <p className="text-sm font-semibold text-burgundy" data-id="element-263">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}